export enum LoaiThuVienEnum {
  HINH_ANH = 'Hình ảnh',

  VIDEO = 'Video',
}
